import { useState, useEffect, useRef } from "react";
import { C, SLIDES as DEFAULT_SLIDES } from "../data";
import Img from "./Img";
import Footer from "./Footer";

export default function HomePage({ products, cat, onSetCat, onGoDetail, nav, navCats, slides: slidesProp, brandImages, siteSettings }) {
  const SLIDES = slidesProp?.length ? slidesProp : DEFAULT_SLIDES;
  const [slide,      setSlide]      = useState(0);
  const [hovCard,    setHovCard]    = useState(null);
  const [visibleCount, setVisibleCount] = useState(8);
  const timerRef    = useRef(null);
  const touchStartX = useRef(null);

  const resetTimer = () => {
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => setSlide(s => (s + 1) % SLIDES.length), 4500);
  };

  const goSlide = (i) => { setSlide(i); resetTimer(); };
  const goPrev  = () => goSlide((slide - 1 + SLIDES.length) % SLIDES.length);
  const goNext  = () => goSlide((slide + 1) % SLIDES.length);

  const onTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; };
  const onTouchEnd   = (e) => {
    if (touchStartX.current === null) return;
    const delta = e.changedTouches[0].clientX - touchStartX.current;
    if (delta < -50) goNext();
    else if (delta > 50) goPrev();
    touchStartX.current = null;
  };

  // 메뉴 설정의 대분류(catFilter)로 필터 버튼 구성
  const filterItems = navCats
    ? ["All", ...navCats.map(c => c.catFilter)]
    : ["All"];

  const filtered = cat === "All" ? products : products.filter(p => p.cat === cat);
  const visible  = filtered.slice(0, visibleCount);
  const hasMore  = filtered.length > visibleCount;

  useEffect(() => { setVisibleCount(8); }, [cat]);

  useEffect(() => {
    resetTimer();
    return () => clearInterval(timerRef.current);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {/* ── HERO ── */}
      <section style={{ position:"relative", height:"calc(100vh - var(--header-h, 60px))", marginTop:"var(--header-h, 60px)", overflow:"hidden", background:"#fff" }}
        onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
        {SLIDES.map((s, i) => (
          <div key={s.id} className="hero-slide" style={{ opacity: i === slide ? 1 : 0 }}>
            <img src={s.img} style={{ width:"100%", height:"100%", objectFit:"cover" }} alt={s.label} />
          </div>
        ))}
        {/* 하단 그라디언트 오버레이 */}
        <div style={{ position:"absolute", inset:0, zIndex:5, background:"linear-gradient(to top, rgba(0,0,0,0.62) 0%, rgba(0,0,0,0.18) 40%, transparent 70%)", pointerEvents:"none" }} />
        <div style={{ position:"absolute", inset:0, zIndex:10, display:"flex", flexDirection:"column", justifyContent:"flex-end", padding:"0 48px 64px" }}>
          <div key={slide} style={{ animation:"fadeUp .55s ease both" }}>
            <p style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:9, letterSpacing:5, color:"rgba(255,255,255,0.55)", marginBottom:10 }}>
              {String(slide + 1).padStart(2,"0")} / {String(SLIDES.length).padStart(2,"0")}
            </p>
            <h1 style={{ fontFamily:"'DM Serif Display',serif", fontWeight:400, fontSize:"clamp(40px,7vw,88px)", lineHeight:1.05, color:"#fff", marginBottom:10 }}>
              {SLIDES[slide].label}
            </h1>
            <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:14, fontWeight:300, color:"rgba(255,255,255,0.7)", marginBottom:24 }}>
              {SLIDES[slide].sub}
            </p>
            <span className="tl-light" onClick={() => document.getElementById("products")?.scrollIntoView({ behavior:"smooth" })}>
              Shop Now <span>→</span>
            </span>
          </div>
        </div>
        {/* 슬라이드 닷 */}
        <div style={{ position:"absolute", right:48, top:"50%", transform:"translateY(-50%)", display:"flex", flexDirection:"column", gap:10, zIndex:10 }}>
          {SLIDES.map((_, i) => (
            <button key={i} onClick={() => goSlide(i)}
              style={{ width:1, height:i===slide?28:10, background:i===slide?C.accent:C.border, border:"none", cursor:"pointer", padding:0, transition:"all .3s" }} />
          ))}
        </div>
      </section>

      {/* ── BANNER ── */}
      <div style={{ background:C.ink, padding:"14px 48px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
        <span style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:9, letterSpacing:5, color:"#444" }}>{siteSettings?.heroBannerLeft || '26 S/S — NOW AVAILABLE'}</span>
        <span style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:9, letterSpacing:4, color:C.accent }}>{siteSettings?.heroBannerCenter || 'FREE SHIPPING OVER ₩100,000'}</span>
        <span style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:9, letterSpacing:5, color:"#444" }}>{siteSettings?.heroBannerRight || 'UNDERLOOKED ✦ SEOUL'}</span>
      </div>

      {/* ── PRODUCTS ── */}
      <section id="products" style={{ maxWidth:1440, margin:"0 auto", padding:"80px 48px" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-end", marginBottom:40 }}>
          <div>
            <p style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:9, letterSpacing:4, color:C.accent, marginBottom:8 }}>New Arrivals</p>
            <h2 style={{ fontFamily:"'DM Serif Display',serif", fontSize:"clamp(26px,4vw,44px)", fontWeight:400, lineHeight:1.1 }}>26 Spring / Summer</h2>
          </div>
          <div style={{ display:"flex", gap:4, flexWrap:"wrap" }}>
            {filterItems.map(c => (
              <button key={c} className={`cat-btn${cat === c ? " on" : ""}`} onClick={() => onSetCat(c)}>{c}</button>
            ))}
          </div>
        </div>

        <div className="prod-grid" style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:2 }}>
          {visible.map(p => (
            <div key={p.id} className="prod-card"
              onMouseEnter={() => setHovCard(p.id)}
              onMouseLeave={() => setHovCard(null)}
              onClick={() => onGoDetail(p.id)}>
              <div className="pimg" style={{ aspectRatio:"3/4" }}>
                <div className="pimg-inner">
                  {p.imgs?.[0]
                    ? <img src={p.imgs[0]} style={{ width:"100%", height:"100%", objectFit:"cover" }} alt={p.name} />
                    : <Img style={{ width:"100%", height:"100%" }} />
                  }
                </div>
                {p.tag && (
                  <div style={{ position:"absolute", top:12, left:12, background:p.tag==="BEST"?C.ink:C.accent, padding:"4px 10px" }}>
                    <span style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:8, letterSpacing:3, color:"#fff" }}>{p.tag}</span>
                  </div>
                )}
                <div style={{ position:"absolute", inset:0, border:hovCard===p.id?`2px solid ${C.accent}`:"2px solid transparent", transition:"border-color .25s", pointerEvents:"none" }} />
              </div>
              <div style={{ paddingTop:12 }}>
                <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:13, color:hovCard===p.id?C.hover:C.ink, fontWeight:hovCard===p.id?700:400, transition:"color .25s", marginBottom:3 }}>{p.name}</p>
                <p style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:9, letterSpacing:3, color:C.accent, marginBottom:3, textTransform:"uppercase" }}>{p.cat}</p>
                {p.discountRate > 0 ? (
                  <div style={{ display:"flex", alignItems:"baseline", gap:6 }}>
                    <span style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:12, color:C.ink, letterSpacing:1 }}>₩{Math.round(p.price * (1 - p.discountRate / 100)).toLocaleString()}</span>
                    <span style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:10, color:C.muted, letterSpacing:1, textDecoration:"line-through" }}>₩{p.price.toLocaleString()}</span>
                    <span style={{ fontFamily:"'Pretendard',sans-serif", fontSize:9, fontWeight:600, color:"#C0392B" }}>{p.discountRate}%</span>
                  </div>
                ) : (
                  <p style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:12, color:C.ink, letterSpacing:1 }}>₩{p.price.toLocaleString()}</p>
                )}
                {(p.shippingFee ?? 0) === 0
                  ? <span style={{ fontFamily:"'Pretendard',sans-serif", fontSize:9, fontWeight:600, letterSpacing:1, color:"#3D8B5C", marginTop:3, display:"inline-block" }}>무료배송</span>
                  : <span style={{ fontFamily:"'Pretendard',sans-serif", fontSize:9, color:C.muted, marginTop:3, display:"inline-block" }}>배송비 ₩{parseInt(p.shippingFee).toLocaleString()}</span>
                }
              </div>
            </div>
          ))}
        </div>

        {hasMore && (
          <div style={{ display:"flex", justifyContent:"center", marginTop:48 }}>
            <button
              onClick={() => setVisibleCount(v => v + 8)}
              style={{
                fontFamily:"'Pretendard',sans-serif", fontWeight:500,
                fontSize:10, letterSpacing:3, textTransform:"uppercase",
                background:"none", border:`1px solid ${C.border}`,
                padding:"14px 48px", cursor:"pointer", color:C.ink,
                transition:"background .2s, color .2s, border-color .2s",
              }}
              onMouseEnter={e => { e.currentTarget.style.background=C.ink; e.currentTarget.style.color=C.bg; e.currentTarget.style.borderColor=C.ink; }}
              onMouseLeave={e => { e.currentTarget.style.background="none"; e.currentTarget.style.color=C.ink; e.currentTarget.style.borderColor=C.border; }}
            >
              더보기 ({filtered.length - visibleCount})
            </button>
          </div>
        )}
      </section>

      {/* ── BRAND STRIP ── */}
      <section style={{ background:C.ink, overflow:"hidden" }}>
        <div style={{ maxWidth:1440, margin:"0 auto" }}>
          <div style={{ padding:"64px 48px 48px" }}>
            <p style={{ fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:9, letterSpacing:5, color:C.accent, marginBottom:24 }}>ABOUT UNDERLOOKED</p>
            <h2 style={{ fontFamily:"'DM Serif Display',serif", fontWeight:400, fontSize:"clamp(28px,4vw,52px)", lineHeight:1.3, color:C.bg, marginBottom:24 }}>
              움직임을 위해<br/>설계된 옷.
            </h2>
            <p style={{ fontFamily:"'Presentation5',sans-serif", fontSize:13, fontWeight:300, lineHeight:2.1, color:"rgba(242,241,237,.45)", marginBottom:40 }}>
              UNDERLOOKED은 스포츠와 일상의 경계를 허무는 옷을 만듭니다. 기능성과 미감 사이의 정밀한 균형, 착용할수록 더욱 자유로워지는 실루엣.
            </p>
            <span className="tl" style={{ color:C.bg, borderColor:"#444" }} onClick={() => nav?.goAbout()}>Brand Story →</span>
          </div>
          <Img src={brandImages?.brandStrip || undefined} style={{ aspectRatio:"3/2", width:"100%", display:"block" }} dark label="BRAND IMAGE" />
        </div>
      </section>

      <Footer nav={nav} variant="full" />
    </>
  );
}
